// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VYH3","fullView":"styles_fullView__2Yqd3"};